import React from 'react'

import PropTypes from 'prop-types'

import './cta.css'

const CTA = (props) => {
  return (
    <div className="thq-section-padding">
      <div className="thq-section-max-width">
        <div className="cta-accent2-bg">
          <div className="cta-accent1-bg">
            <div className="cta-container2">
              <div className="cta-content">
                <span className="thq-heading-2">{props.heading1}</span>
                <p className="thq-body-large">{props.content1}</p>
              </div>
              <div className="cta-actions">
                <a
                  href="https://book.squareup.com/appointments/x3k8budz1ctfgx/location/T1GPHC1Z2QE6W/services"
                  target="_blank"
                  rel="noreferrer noopener"
                  className="cta-link thq-button-filled"
                >
                  {props.action1}
                </a>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  )
}

CTA.defaultProps = {
  heading1: 'Book a Free Security Checkup',
  content1:
    'Schedule a complimentary security assessment to safeguard your digital assets.',
  action1: 'Schedule Now',
}

CTA.propTypes = {
  heading1: PropTypes.string,
  content1: PropTypes.string,
  action1: PropTypes.string,
}

export default CTA
